import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { useTheme, THEME_PRESETS } from "../ThemeContext";
import { FaPalette, FaCheck } from "react-icons/fa";

export default function ThemePickerModal({ show, onHide }) {
    const { theme, updateTheme, isSaving } = useTheme();
    const [selectedThemeId, setSelectedThemeId] = useState(theme?.id || "purple");

    const handleSave = async () => {
        const newTheme = THEME_PRESETS.find((t) => t.id === selectedThemeId);
        if (newTheme) {
            await updateTheme(newTheme);
            onHide();
        }
    };

    return (
        <Modal show={show} onHide={onHide} centered className="premium-modal">
            <Modal.Header closeButton>
                <Modal.Title>
                    <FaPalette className="mr-2" /> Change Theme
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="theme-selector">
                    {THEME_PRESETS.map((t) => (
                        <div
                            key={t.id}
                            className={`theme-option ${selectedThemeId === t.id ? "selected" : ""
                                }`}
                            onClick={() => setSelectedThemeId(t.id)}
                            style={{
                                cursor: "pointer",
                                border:
                                    selectedThemeId === t.id
                                        ? "2px solid var(--primary-color)"
                                        : "1px solid rgba(0,0,0,0.1)",
                                borderRadius: "8px",
                                padding: "10px",
                                marginBottom: "10px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                background:
                                    selectedThemeId === t.id
                                        ? "rgba(102, 126, 234, 0.05)"
                                        : "transparent",
                            }}
                        >
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <div
                                    className="theme-preview"
                                    style={{
                                        width: "30px",
                                        height: "30px",
                                        borderRadius: "50%",
                                        background: `linear-gradient(135deg, ${t.colors.primary}, ${t.colors.secondary})`,
                                        marginRight: "10px",
                                    }}
                                ></div>
                                <span style={{ fontWeight: 500 }}>{t.name}</span>
                            </div>
                            {selectedThemeId === t.id && (
                                <FaCheck style={{ color: "var(--primary-color)" }} />
                            )}
                        </div>
                    ))}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Cancel
                </Button>
                <Button
                    className="primary-gradient-btn"
                    onClick={handleSave}
                    disabled={isSaving}
                >
                    {isSaving ? "Saving..." : "Apply Theme"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
